export const footerAustralia = {
  vat_no: 'GST #',
}
